export default __webpack_public_path__ + "static/media/mr_mrs_smith_m2.714b9eaa.png";